export default "__VITE_ASSET__Cf0Ec8yj__"